import { ConfigApi } from '@backstage/core-plugin-api';

/**
 * Returns true when the UI should use the built-in mock client.
 *
 * - `mock: true`  → always mock.
 * - `mock: false` → real HTTP client via Backstage service discovery.
 * - `mock` absent → mock (safe default until the backend is deployed).
 */
export function shouldUseCustomMetricsMock(config: ConfigApi): boolean {
  return config.getOptionalBoolean('app.customMetrics.mock') !== false;
}
